import { __decorate, __metadata } from "tslib";
import { DocumentStatus } from '@cbbt/itf-onboarding-common';
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { PartyDetailsRequest } from '../documents/CaseDetailsRequest.js';
export class IdvCaseDetails extends BaseMessage {
    caseId;
    processCode;
    caseReferenceNo;
    caseStatus;
    id;
    journeyDocumentStatus;
    partyDetails;
}
__decorate([
    Field.number({
        description: 'Case id',
        required: true,
        numberType: 'integer',
    }),
    __metadata("design:type", Number)
], IdvCaseDetails.prototype, "caseId", void 0);
__decorate([
    Field.string({
        description: 'ProcessCode',
        required: true,
        minLength: 1,
    }),
    __metadata("design:type", String)
], IdvCaseDetails.prototype, "processCode", void 0);
__decorate([
    Field.string({
        description: 'CaseReferenceNo',
        required: true,
        minLength: 1,
    }),
    __metadata("design:type", String)
], IdvCaseDetails.prototype, "caseReferenceNo", void 0);
__decorate([
    Field.string({
        description: 'caseStatus',
        required: true,
        minLength: 1,
    }),
    __metadata("design:type", String)
], IdvCaseDetails.prototype, "caseStatus", void 0);
__decorate([
    Field.string({
        description: 'Document Id',
        required: false,
        format: 'uuid',
    }),
    __metadata("design:type", String)
], IdvCaseDetails.prototype, "id", void 0);
__decorate([
    Field.enum({
        enum: DocumentStatus,
        description: 'Journey Document Status',
        required: false,
    }),
    __metadata("design:type", String)
], IdvCaseDetails.prototype, "journeyDocumentStatus", void 0);
__decorate([
    Field.array({
        required: true,
        minItems: 1,
        items: {
            type: 'message',
            message: PartyDetailsRequest,
        },
    }),
    __metadata("design:type", Array)
], IdvCaseDetails.prototype, "partyDetails", void 0);
//# sourceMappingURL=IdvCaseDetails.js.map